import { LOCAL_STORAGE_KEYS } from '../../constants/AppConstants';
import { PBStorage } from '../../services/storageService/GlobalData';

class InstanceManager {
  async saveInstances(InstancesToSave, activityId) {
    try {
      let instances = (await PBStorage.get(LOCAL_STORAGE_KEYS.INSTANCES)) || [];

      if (instances) {
        let filtered = instances.filter(
          (q) => q.feedlot_activity_id != activityId,
        );
        let instanceArr = [...InstancesToSave, ...filtered];

        await PBStorage.set(LOCAL_STORAGE_KEYS.INSTANCES, instanceArr);
      } else {
        await PBStorage.set(LOCAL_STORAGE_KEYS.INSTANCES, InstancesToSave);
      }

      return true;
    } catch (e) {
      console.log('InstancesToSave Failed', e);
      return false;
    }
  }

  async getInstancesByActivityId(activityId) {
    let instances = await PBStorage.get(LOCAL_STORAGE_KEYS.INSTANCES);
    if (instances) {
      instances = JSON.parse(instances);
      let filtered = instances.filter(
        (q) => q.feedlot_activity_id == activityId,
      );
      return filtered;
    }

    return [];
  }
}

export default new InstanceManager();
